import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
export function FailedMethodsSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      x: -20
    },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section className="bg-navy-800 text-white py-16 md:py-24 px-4" data-id="element-2">
      <div className="max-w-4xl mx-auto" data-id="element-3">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-4">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-5">
            ¿Por qué lo que has intentado{' '}
            <span className="text-red-400" data-id="element-6">no funciona</span>?
          </h2>
        </motion.div>

        <motion.ul variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="space-y-6" data-id="element-7">
          <motion.li variants={itemVariants} className="flex items-start bg-navy-900 p-6 rounded-xl border border-slate-700/50" data-id="element-8">
            <div className="bg-red-500/10 p-2 rounded-full mr-4 shrink-0 mt-1" data-id="element-9">
              <XIcon className="w-6 h-6 text-red-400" data-id="element-10" />
            </div>
            <p className="text-lg text-slate-300" data-id="element-11">
              <strong className="text-white block mb-1" data-id="element-12">
                El Dropshipping de China falla
              </strong>
              porque los envíos tardan 30 días y los clientes en USA no esperan.
            </p>
          </motion.li>

          <motion.li variants={itemVariants} className="flex items-start bg-navy-900 p-6 rounded-xl border border-slate-700/50" data-id="element-13">
            <div className="bg-red-500/10 p-2 rounded-full mr-4 shrink-0 mt-1" data-id="element-14">
              <XIcon className="w-6 h-6 text-red-400" data-id="element-15" />
            </div>
            <p className="text-lg text-slate-300" data-id="element-16">
              <strong className="text-white block mb-1" data-id="element-17">
                Vender productos por catálogo
              </strong>
              te deja márgenes minúsculos y requiere que persigas a tus amigas.
            </p>
          </motion.li>

          <motion.li variants={itemVariants} className="flex items-start bg-navy-900 p-6 rounded-xl border border-slate-700/50" data-id="element-18">
            <div className="bg-red-500/10 p-2 rounded-full mr-4 shrink-0 mt-1" data-id="element-19">
              <XIcon className="w-6 h-6 text-red-400" data-id="element-20" />
            </div>
            <p className="text-lg text-slate-300" data-id="element-21">
              <strong className="text-white block mb-1" data-id="element-22">
                Los cursos técnicos complejos
              </strong>
              te confunden con términos en inglés que nadie te explica.
            </p>
          </motion.li>

          <motion.li variants={itemVariants} className="flex items-start bg-navy-900 p-6 rounded-xl border border-slate-700/50" data-id="element-23">
            <div className="bg-red-500/10 p-2 rounded-full mr-4 shrink-0 mt-1" data-id="element-24">
              <XIcon className="w-6 h-6 text-red-400" data-id="element-25" />
            </div>
            <p className="text-lg text-slate-300" data-id="element-26">
              <strong className="text-white block mb-1" data-id="element-27">
                Intentar "adivinar" qué vender en redes sociales
              </strong>
              te hace perder dinero en anuncios que no traen ni una venta.
            </p>
          </motion.li>
        </motion.ul>
      </div>
    </section>;
}